import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CheckoutCommonTC } from './checkout-commonTC';
import { DirectivesModule } from '../../directives/directives.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/components/components.module';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    CheckoutCommonTC
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild([{ path: '', component: CheckoutCommonTC }]),
    ComponentsModule,
    DirectivesModule,
    SharedModule
  ],
})
export class CheckoutCommonTCModule { }
